import { render } from "./OrderPlaced.vue?vue&type=template&id=ac303c82"
import script from "./OrderPlaced.vue?vue&type=script&lang=js"
export * from "./OrderPlaced.vue?vue&type=script&lang=js"

import "./OrderPlaced.vue?vue&type=style&index=0&id=ac303c82&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__